import { ShieldCheck } from "lucide-react";

// ────────────────────────────────────────────────────────────────
// TrustBand — a muted footer-style strip that lists the compliance
// posture lawyers expect to see somewhere on every page.
//
// Visual goal: "this product is enterprise-ready and someone is
// accountable for our data." Not a hero, not a banner — a small line
// at the bottom of a page, like a memo's footer.
//
// All copy hardcoded for now. If we ever certify more, just add to
// the list. Account team contact is a mailto, so a partner who's
// concerned can email a real human in two clicks.
// ────────────────────────────────────────────────────────────────

function TrustBand({
  accountManagerName = "Attri Support",
  accountManagerEmail = "support@attri.ai",
  region = "US East",
}: {
  accountManagerName?: string;
  accountManagerEmail?: string;
  region?: string;
}) {
  return (
    <div className="mt-8 pt-4 border-t border-border-subtle flex flex-wrap items-center gap-x-4 gap-y-2 text-[11.5px] text-fg-muted">
      <span className="inline-flex items-center gap-1.5">
        <ShieldCheck size={12} className="text-success" />
        <span>SOC 2 Type II</span>
      </span>
      <Dot />
      <span>ISO 27001</span>
      <Dot />
      <span>GDPR-aligned</span>
      <Dot />
      <span>
        Data resident in <span className="text-fg-default">{region}</span>
      </span>
      <Dot />
      <span>
        Account team:{" "}
        <a
          href={`mailto:${accountManagerEmail}`}
          className="text-fg-default hover:text-fg-strong underline-offset-2 hover:underline"
        >
          {accountManagerName}
        </a>
      </span>
    </div>
  );
}

function Dot() {
  return (
    <span
      className="inline-block w-1 h-1 rounded-full bg-fg-muted opacity-40"
      aria-hidden
    />
  );
}

export default TrustBand;
